export default "__VITE_PUBLIC_ASSET__1f374701__"